export default "__VITE_ASSET__D3$m1ysR__"